import React from 'react';
import __ from "../../../i18n";
import InlineEditButton from "../components/inline-edit-button/InlineEditButton";
import EnrollmentStatusView from "../../../widgets/enrollment-status-view/EnrollmentStatusView";
import EnrollmentStatusEditor from "../../../editors/enrollment-status/EnrollmentStatusEditor";


function getColumnConfigs({updateItem, refreshData, refs}) {
    return [
        {
            key: 'status',
            name: null,
            sortable: true,
            renderValue: (value) => <EnrollmentStatusView value={value} showsLabel={false}/>,
            renderEditor: (item, onSubmittingChange, close) => {
                return <EnrollmentStatusEditor
                    recordId={item.id}
                    defaultValues={item}
                    onDone={values => {
                        updateItem(item.id, values);
                        close();
                    }}
                    onSubmittingChange={onSubmittingChange}
                    onCancel={close}
                />;
            }
        },
        {
            key: 'id',
            name: __('ID'),
            sortable: true
        },
        {
            key: 'course_id',
            name: __('Course'),
            sortable: true,
            renderValue: (value) => {
                const course = refs.courses.find(t => t.id === value);
                return <div className="item-view">
                    <p>{course.name}</p>
                    <p>{__('ID: ::id', {id: String(value)})}</p>
                </div>;
            }
        },
        {
            key: 'student_id',
            name: __('Student'),
            sortable: true,
            renderValue: (value) => {
                const student = refs.users.find(t => t.id === value);
                return <div className="item-view">
                    <p>{student.full_name}</p>
                    <p>{student.email}</p>
                    <p>{student.phone}</p>
                </div>;
            }
        },
        {
            key: 'fee',
            name: __('Fee'),
            sortable: true,
            renderValue: (value) => __('::amount(CURRENCY, symbol)', {amount: value})
        },
        {
            key: 'create_time',
            name: __('Created'),
            sortable: true,
            renderValue: (value) => __('::date(DATE, dateTime)', {date: value})
        },
        {
            key: '*edit',
            name: __('Edit'),
            sortable: false,
            renderValue: (_, item) => <InlineEditButton
                item={item}
                onDone={(values) => refreshData()}
            />
        }
    ];
}

export default {
    getColumnConfigs
};
